module.exports = btmShared.bamBrowserSDK;